<script>
import { navigateTo } from 'svelte-router-spa';
import { onMount } from 'svelte';

import SvelteSeo from 'svelte-seo';


onMount(() => {
	navigateTo('/forms');
});

</script>

